exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.groupNumbers {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n}\n.groupNumbers div {\n    display: flex;\n    flex-direction: row;\n}\n.groupNumbers p {\n    font-size: 3em;\n    margin-top: 0em;\n    margin-bottom: 0.3em;\n}\n", ""]);

